import styled from '~/app/components/styled'
import { Typography } from '@yanolja-org/ya-com-core'

const Container = styled.div`
  padding: 1.6rem;
  margin-top: 1.6rem;
  border-radius: 0.4rem;
  border: solid 1px ${({ theme }) => theme.color.yaorange200};
  background-color: ${({ theme }) => theme.color.yaorange50};
  word-break: keep-all;
  color: ${({ theme }) => theme.color.gray900};
  ${Typography('body2.multiline').regular};
`

const LeisureCancelRequestedNotice = () => {
  return <Container>{'국내레저 상품은 취소 완료까지 최대 7일이 걸립니다'}</Container>
}

export default LeisureCancelRequestedNotice
